// @ts-strict-ignore
import { FC, useMemo } from 'react'

import { getCartServicesPriceByProduct, TCartItem } from '@/entities/cart'

import { useBreakpoints } from '@/shared/lib/hooks/useBreakpoints'
import { getTotalSetText } from '@/shared/lib/utils/getTotalSetText'
import { formatPrice } from '@/shared/lib/utils/price/format-price'
import Flex from '@/shared/ui/Flex'

import { TotalDrawerContent } from './TotalDrawerContent/TotalDrawerContent'
import { TotalPopoverContent } from './TotalPopoverContent/TotalPopoverContent'

import cl from './total-product-set-item.module.scss'

export type DeleteItemClick = (
	basketID: number,
	productId: number,
	isRelatedProductInCart: boolean,
	isAcsProduct: boolean
) => void

type TotalProductSetItemProps = {
	onDeleteClick?: DeleteItemClick
	item: TCartItem
	ID: number
	relatedItems?: TCartItem[]
	hidePrice?: boolean
}

export type TotalProductInfoProps = Pick<TotalProductSetItemProps, `relatedItems` | `onDeleteClick`> & {
	totalText: string
	formattedPrice: string
	hidePrice?: boolean
}

/**
 * Wrapper component for content displaying
 * a list of active services and accessories on the product page
 *
 * @param props
 * @param props.relatedItems - list of accessories and services
 * @param props.item - parent product
 * @param props.ID - ID of parent product
 * @param props.onDeleteClick - Method for deleting an item
 *
 * */
export const TotalProductSetItem: FC<TotalProductSetItemProps> = ({ onDeleteClick, ID, relatedItems, hidePrice }) => {
	const { isLessThanBreakpoint } = useBreakpoints()
	const isMobile = isLessThanBreakpoint(`Sm`)
	const priceOfAcsAndServices: number = getCartServicesPriceByProduct(relatedItems, ID)
	const formattedPrice = formatPrice(priceOfAcsAndServices)
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const totalText = useMemo(() => getTotalSetText(relatedItems, ID), [relatedItems])

	return (
		<li className={cl.totalProductSetItem}>
			<dl className={cl.totalProductSetItem__dl}>
				<Flex alignCenter>
					{/* Title */}
					<dt className={cl.totalProductSetItem__title}>
						<div className={cl.totalProductSetItem__titleInner}>
							{isMobile ? (
								<TotalDrawerContent
									relatedItems={relatedItems}
									onDeleteClick={onDeleteClick}
									totalText={totalText}
									formattedPrice={formattedPrice}
								/>
							) : (
								<TotalPopoverContent
									relatedItems={relatedItems}
									onDeleteClick={onDeleteClick}
									totalText={totalText}
									formattedPrice={formattedPrice}
									hidePrice={hidePrice}
								/>
							)}
						</div>
					</dt>
				</Flex>
			</dl>
		</li>
	)
}
